import { createContext, useContext, useState, useEffect } from "react";
import { api, setFiscalYear, computeCurrentFY } from "@/lib/api";

const Ctx = createContext(null);
export const useFiscalYear = () => useContext(Ctx);

// A deliberately chosen other year lives only in this browser tab/session; a tab simply left on what
// used to be the current year rolls forward to the new FY on next load.
const initialFY = () => {
  localStorage.removeItem("fy");
  const cur = computeCurrentFY();
  const picked = sessionStorage.getItem("fy");
  const pickedWhenCurrentWas = sessionStorage.getItem("fy_current_at_pick");
  if (!picked || (picked === pickedWhenCurrentWas && picked !== cur)) return cur;
  return picked;
};

export const FiscalYearProvider = ({ children }) => {
  const [fy, setFyState] = useState(initialFY);
  // set synchronously so the axios interceptor tags requests before children fetch
  setFiscalYear(fy);
  const [years, setYears] = useState([fy]);

  useEffect(() => {
    setFiscalYear(fy);
    sessionStorage.setItem("fy", fy);
    sessionStorage.setItem("fy_current_at_pick", computeCurrentFY());
  }, [fy]);

  useEffect(() => {
    api.get("/fiscal-years").then(({ data }) => {
      const ys = data.years && data.years.length ? data.years : [fy];
      setYears(ys.includes(fy) ? ys : [fy, ...ys].sort().reverse());
    }).catch(() => {});
  }, [fy]);

  return (
    <Ctx.Provider value={{ fy, setFy: setFyState, years, currentFY: computeCurrentFY() }}>{children}</Ctx.Provider>
  );
};
